import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';

var Robot =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Robot, _PureComponent);

  function Robot() {
    _classCallCheck(this, Robot);

    return _possibleConstructorReturn(this, _getPrototypeOf(Robot).apply(this, arguments));
  }

  _createClass(Robot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bsStyle = _this$props.bsStyle,
          size = _this$props.size,
          alternate = _this$props.alternate;
      return React.createElement("div", {
        className: "robot robot-".concat(size)
      }, React.createElement("div", {
        className: "robot-bg"
      }, React.createElement(ReactSVG, {
        path: "https://static.ux.cimpress.io/assets/images/bg_diamond-".concat(bsStyle, ".svg")
      })), React.createElement("div", {
        className: "robot-figure"
      }, React.createElement(ReactSVG, {
        path: "https://static.ux.cimpress.io/assets/images/robot-".concat(bsStyle).concat(alternate ? '-2' : '', ".svg")
      })));
    }
  }]);

  return Robot;
}(PureComponent);

export { Robot as default };
Robot.propTypes = {
  bsStyle: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
  size: PropTypes.oneOf(['sm', 'lg']),
  alternate: PropTypes.bool
};
Robot.defaultProps = {
  bsStyle: 'success',
  size: 'sm'
};